export enum FieldType {
    Object = 'object',
    Array = 'array',
    Primitive = 'primitive'
}
